import { mapState } from 'vuex'
import { Bar } from 'vue-chartjs'
import { set } from 'lodash'
import { shortenText } from '@/lib/utils/utils.js'
import { DEFAULT_PALETTE, DARK_DEFAULT_PALETTE } from '@/lib/colors.js'

export default {
  mixins: [Bar],
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    chartOptions: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    this.render()
  },
  computed: {
    ...mapState(['hideAmounts']),
    isMobile() {
      return this.$vuetify.breakpoint.xs
    },
  },
  watch: {
    '$vuetify.theme.dark'() {
      this.render()
    },
    hideAmounts() {
      this.render()
    },
  },
  methods: {
    render() {
      let myData, myOptions

      const noData = this.chartData.datasets.every(
        (dataset) => dataset.data.length === 0 || dataset.data.every((item) => item === 0)
      )
      if (!noData) {
        myData = { ...this.chartData }
        myOptions = { ...this.chartOptions }

        myData.labels = myData.labels.map((elem) => {
          if (this.isMobile) return shortenText(elem, 12)
          return shortenText(elem, 20)
        })
      } else {
        myData = {
          datasets: [
            {
              data: [500, 1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000],
              backgroundColor: this.$vuetify.theme.dark
                ? 'rgba(41, 41, 41, 0.4)'
                : 'rgba(247, 248, 251, 0.7)',
            },
          ],
          labels: ['', '', '', '', '', '', '', '', '', '', ''],
        }
        myOptions = {
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: false,
                },
                ticks: {
                  display: false,
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  display: false,
                },
                gridLines: {
                  zeroLineColor: this.$vuetify.theme.dark
                    ? DARK_DEFAULT_PALETTE.dark_backgroundLighterBlack
                    : DEFAULT_PALETTE.softBackgroundGrey,
                },
              },
            ],
          },
          legend: {
            display: false,
          },
          tooltips: {
            enabled: false,
          },
          hover: { mode: null },
        }
      }

      set(
        myOptions,
        'legend.labels.fontColor',
        this.$vuetify.theme.dark ? DARK_DEFAULT_PALETTE.dark_Textgrey : DEFAULT_PALETTE.darkTextGrey
      )
      set(
        myOptions,
        'scales.xAxes[0].ticks.fontColor',
        this.$vuetify.theme.dark ? DARK_DEFAULT_PALETTE.dark_Textgrey : DEFAULT_PALETTE.darkTextGrey
      )
      set(
        myOptions,
        'scales.yAxes[0].gridLines.color',
        this.$vuetify.theme.dark
          ? DARK_DEFAULT_PALETTE.dark_backgroundLighterBlack
          : DEFAULT_PALETTE.softBackgroundGrey
      )
      set(
        myOptions,
        'scales.yAxes[0].ticks.fontColor',
        this.$vuetify.theme.dark ? DARK_DEFAULT_PALETTE.dark_Textgrey : DEFAULT_PALETTE.darkTextGrey
      )
      set(myOptions, 'scales.yAxes[0].gridLines.drawBorder', false)

      this.renderChart(myData, myOptions)
    },
  },
}
